import React from 'react';
import { Checkbox, Row, Col, Tooltip } from 'antd';
import { connect } from 'dva';

const ScanRunningInstances = props => {
  const { deployedCftCheck, scanRunningInstances } = props;

  if (!deployedCftCheck) return;

  return (
    <>
      <h5 style={{ margin: '20px 0' }}>Choose Configuration</h5>
      <div
        style={{
          background: '#fafafa',
          margin: '25px 0',
          borderRadius: '8px',
          border: '1px solid #d9d9d9',
          padding: '1rem 2rem',
        }}
      >
        <Row>
          <Col span={24}>
            <Row
              gutter={24}
              style={{
                marginBottom: '10px',
              }}
            >
              <Col>
                <p>
                  This configuration is recommended to
                  first-time users for a much quicker & cost-efficient process. Unselecting this
                  configuration will make Cloudxray scan all your EC2 instances - running instances
                  as well as stopped instances. You can change this later from this Cloud Account's
                  configurations.
                </p>
              </Col>
            </Row>
            <Row
              gutter={24}
              style={{
                marginBottom: '20px',
              }}
            >
              <Col span={14}>
                <Tooltip placement="bottom" title={!deployedCftCheck && 'Please deploy CFT first'}>
                  <Checkbox
                    checked={scanRunningInstances}
                    name="scanRunningInstances"
                    onChange={e => {
                      const { dispatch } = props;
                      dispatch({
                        type: 'cloudAccount/save',
                        payload: { scanRunningInstances: e.target.checked },
                      });
                    }}
                  >
                    Scan running instances only.
                  </Checkbox>
                </Tooltip>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default connect(({ cloudAccount }) => ({
  scanRunningInstances: cloudAccount.scanRunningInstances,
}))(ScanRunningInstances);
